(function () {
  var regionData = [
    {
      title: 'USA',
      eyebrow: 'Everyday pride',
      detail: 'Wear the flag that feels like home',
      href: '/products/usa-flag-bracelet-mens-and-womens-handmade',
      image: 'https://cdn.shopify.com/s/files/1/0682/1271/9765/files/fahari-region-usa-lifestyle-square.jpg?v=1787351869'
    },
    {
      title: 'Africa',
      eyebrow: 'Continental pride',
      detail: 'Explore flags from across the continent',
      href: '/collections/africa',
      image: 'https://cdn.shopify.com/s/files/1/0682/1271/9765/files/fahari-region-africa-lifestyle-square.jpg?v=1787351877'
    },
    {
      title: 'Europe',
      eyebrow: 'Classic heritage',
      detail: 'Timeless flags, handmade in color',
      href: '/collections/europe',
      image: 'https://cdn.shopify.com/s/files/1/0682/1271/9765/files/fahari-region-europe-lifestyle-square.jpg?v=1787351885'
    },
    {
      title: 'S. America',
      eyebrow: 'Bright color',
      detail: 'Bold flags with unmistakable energy',
      href: '/collections/south-america',
      image: 'https://cdn.shopify.com/s/files/1/0682/1271/9765/files/fahari-region-south-america-lifestyle-square.jpg?v=1787351897'
    }
  ];

  var css = [
    '.fh-region-section{background:#f7f3ea!important;overflow:hidden!important}',
    '.fh-region-section .fh-section__head{margin-bottom:28px!important}',
    '.fh-region-grid{display:grid!important;grid-template-columns:repeat(4,minmax(0,1fr))!important;gap:18px!important;overflow:visible!important;padding:0!important}',
    '.fh-region-card{position:relative!important;display:block!important;aspect-ratio:1/1!important;min-height:0!important;border-radius:0!important;overflow:hidden!important;background:#111!important;color:#fff!important;text-decoration:none!important;box-shadow:0 18px 45px rgba(38,31,18,.12)!important}',
    '.fh-region-card.is-hidden{display:none!important}',
    '.fh-region-card__image{position:absolute!important;inset:0!important;width:100%!important;height:100%!important;object-fit:cover!important;object-position:center!important;padding:0!important;background:#111!important;transform:none!important;transition:transform .45s ease!important}',
    '.fh-region-card:after{content:""!important;position:absolute!important;inset:0!important;background:linear-gradient(180deg,rgba(0,0,0,.04) 20%,rgba(0,0,0,.08) 48%,rgba(0,0,0,.40) 100%)!important;z-index:1!important;pointer-events:none!important}',
    '.fh-region-card__content{position:absolute!important;z-index:2!important;left:18px!important;right:18px!important;bottom:18px!important;display:block!important;padding:18px!important;background:rgba(8,8,8,.48)!important;backdrop-filter:blur(3px)!important;border-left:4px solid #c59b43!important}',
    '.fh-region-card__eyebrow{display:block!important;color:#d6ad4b!important;font-size:10px!important;font-weight:800!important;letter-spacing:.16em!important;text-transform:uppercase!important;margin-bottom:7px!important}',
    '.fh-region-card__title{display:block!important;color:#fff!important;font-size:clamp(27px,2.2vw,38px)!important;line-height:.95!important;font-weight:800!important;letter-spacing:0!important;margin:0 0 8px!important;text-transform:none!important}',
    '.fh-region-card__countries{display:block!important;color:rgba(255,255,255,.88)!important;font-size:13px!important;line-height:1.38!important}',
    '.fh-region-card__explore{display:inline-block!important;margin-top:12px!important;color:#f1cd76!important;border-bottom:1px solid rgba(241,205,118,.65)!important;font-size:12px!important;font-weight:800!important;letter-spacing:0!important;text-transform:none!important}',
    '.fh-region-card__arrow{position:absolute!important;z-index:3!important;right:16px!important;top:16px!important;width:42px!important;height:42px!important;border-radius:50%!important;background:#fff!important;color:#111!important;border:0!important;display:grid!important;place-items:center!important;font-size:20px!important;box-shadow:0 8px 20px rgba(0,0,0,.18)!important}',
    '.fh-region-card:hover .fh-region-card__image{transform:scale(1.035)!important}',
    '@media (max-width:990px){.fh-region-section{padding-top:46px!important}.fh-region-section .fh-container{width:100%!important;padding:0 16px!important}.fh-region-heading{font-size:46px!important;line-height:.95!important}.fh-region-intro{font-size:16px!important;line-height:1.55!important}.fh-region-section .fh-link{display:inline-block!important;margin-top:18px!important;font-size:16px!important}.fh-region-grid{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:12px!important;overflow:visible!important;scroll-snap-type:none!important}.fh-region-card{width:100%!important;flex:none!important}.fh-region-card__content{left:8px!important;right:8px!important;bottom:8px!important;padding:10px!important;background:rgba(8,8,8,.42)!important}.fh-region-card__eyebrow{font-size:8px!important;letter-spacing:.12em!important}.fh-region-card__title{font-size:22px!important}.fh-region-card__countries{display:none!important}.fh-region-card__explore{font-size:9px!important;margin-top:6px!important}.fh-region-card__arrow{width:34px!important;height:34px!important;right:10px!important;top:10px!important;font-size:17px!important}}',
    '@media (min-width:991px) and (max-width:1240px){.fh-region-grid{grid-template-columns:repeat(2,minmax(0,1fr))!important}}',
    '@media (max-width:749px){body:has(.localization-form__select[aria-expanded="true"]),body:has(.disclosure__button[aria-expanded="true"]){overflow:hidden!important}.localization-form__list,.disclosure__list,.country-selector__list,.localization-selector.link + .disclosure__list{max-height:min(62vh,560px)!important;overflow-y:auto!important;-webkit-overflow-scrolling:touch!important;padding-bottom:110px!important}.localization-form,.disclosure{max-height:calc(100vh - 130px)!important}.footer__localization,.lang__currency-desktop{position:relative!important;z-index:80!important}}'
  ].join('\n');

  function addStyle() {
    if (document.getElementById('fh-region-live-fix')) return;
    var style = document.createElement('style');
    style.id = 'fh-region-live-fix';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function updateRegions() {
    var cards = document.querySelectorAll('.fh-region-grid .fh-region-card');
    if (!cards.length) return;
    regionData.forEach(function (item, index) {
      var card = cards[index];
      if (!card) return;
      card.classList.remove('is-hidden');
      card.href = item.href;
      var img = card.querySelector('.fh-region-card__image');
      if (img) {
        img.src = item.image;
        img.alt = item.title + ' flag bracelet collection';
      }
      var eyebrow = card.querySelector('.fh-region-card__eyebrow');
      var title = card.querySelector('.fh-region-card__title');
      var countries = card.querySelector('.fh-region-card__countries');
      var explore = card.querySelector('.fh-region-card__explore');
      if (eyebrow) eyebrow.textContent = item.eyebrow;
      if (title) title.textContent = item.title;
      if (countries) countries.textContent = item.detail;
      if (explore) explore.textContent = 'Explore ' + item.title + ' ->';
    });
    Array.prototype.slice.call(cards, regionData.length).forEach(function (card) {
      card.classList.add('is-hidden');
    });
  }

  function run() {
    addStyle();
    updateRegions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('pageshow', run);
})();
